<div class="d-flex flex-column gap-5 container-lg step-final-container">
  <mat-card class="card-general">
    <mat-card-title>Datos del paciente</mat-card-title>
    <mat-card-content class="d-flex flex-column gap-4">
      <div class="row">
        <div class="col-12 col-sm-6 gap-5">
          <strong>Paciente: </strong>
          <p style="display: inline-block;">{{currentCase.patientFullName}}</p>
        </div>
        <div class="col-12 col-sm-6 gap-5">
          <strong>Fecha alta: </strong>
          <p style="display: inline-block;">{{(currentCase.createdDate | dynamic: 'dateTime')}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 gap-5">
          <strong>Edad: </strong>
          <p style="display: inline-block;">{{(currentCase.patientBirthday | dynamic: 'age')}}</p>
        </div>
        <div class="col-12 col-sm-6 gap-5">
          <strong>Correo: </strong>
          <p style="display: inline-block;">{{currentCase.patientEmail}}</p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="w-100 w-sm-50 mx-auto d-flex flex-column gap-5">
    <h2 class="col text-justify"><strong>¡Listo!</strong> Hemos recibido tus instrucciones para el <strong>Setup Digital</strong>. Ahora lo que sigue es:</h2>
    <div class="text-justify">
      <p>
        <b>1. REVISIÓN: </b>Revisaremos tus archivos y prescripción en un día hábil. Si hay algún error en los archivos te lo haremos saber. Una vez aprobados los archivos, recibirás un correo de confirmación de que hemos empezado a trabajar tu setup.
      </p>
      <p>
        <b>2. SETUP: </b>Trabajaremos en la propuesta de setup, y cuando esté lista recibirás un correo y podrás validarlo en la plataforma para aprobarlo.
      </p>
      <p>
        <b>3. FABRICACIÓN: </b>Cuando hayas aprobado tu setup, comenzaremos con la fabricación y recibirás un correo con tiempo estimado de envío. 
      </p>
      <p>
        <b>4. ENVÍO: </b>Por último te notificaremos cuando se haya enviado por paquetería y el número de rastreo (si aplica).
      </p>
    </div>
   

    <p><b>Si ya sabes el paquete que deseas asignar al caso, hazlo de una vez. Si no, podrás asignar el paquete antes de aprobar el setup.</b></p>
    <div class="row gx-4 gy-4">
      <div class="col-12 col-sm-12 col-lg-6">
        <button mat-button class="button secondary-button" (click)="buyNewProductClicked()"><span style="white-space:normal">Comprar paquete <mat-icon>shopping_cart</mat-icon> </span></button>
      </div>
      <div class="col-12 col-sm-12 col-lg-6">
        <button mat-button class="button terciary-button" (click)="getPurchasedProducts()"><span style="white-space:normal">Asignar de mi stock de paquetes <mat-icon>chevron_right</mat-icon> </span></button>
      </div>
    </div>
    <div class="row">
      <button mat-button class="button primary-button col-12" (click)="onGoToCaseDetail()"><span style="white-space:normal">Comprar paquete más tarde... <mat-icon>timer</mat-icon></span></button>
    </div>
  </div>
</div>

<app-dialog #productCatalogDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" height="auto" width="90%">
  <ng-container *ngIf="isProductCatalogStorage">
    <app-product-list></app-product-list>
  </ng-container>
  <ng-container *ngIf="!isProductCatalogStorage">
    <app-purchased-product-list></app-purchased-product-list>
  </ng-container>

</app-dialog>
